import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ProductOrderConfig } from '../../../types/pricing-feature.types';

const defaultProductOrderConfig: ProductOrderConfig = {
  skipRedirectOnSuccess: false,
};
type KProductOrderConfig = keyof ProductOrderConfig;

@Injectable()
export class ProductOrderConfigService {
  public readonly setup: ProductOrderConfig;

  constructor(private route: ActivatedRoute) {
    const params = route.snapshot.queryParams || {};
    const configKeys = Object.keys(defaultProductOrderConfig);

    const config = { ...defaultProductOrderConfig };

    configKeys.forEach((key: KProductOrderConfig) => {
      if (params[key] === undefined) return;
      if (typeof config[key] === 'boolean') {
        config[key] = params[key] === 'true';
      }
    });

    this.setup = config;
  }
}
